import React, { Component } from 'react';
import{
    Container,
    Button,
    Modal,
    ModalBody,
    ModalFooter
} from 'reactstrap';
/**
 * Used for the Listino Prezzi section. 
 */
export class OrdiniFilter extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);

        this.state = {
            modalOpen: false,      
        };
    
    }

    toggle() {
        this.setState({
            modalOpen: !this.state.modalOpen,
        });
    }

    handleAnnulla = () => {
        this.toggle();
        this.props.annulla();
    }
    
    handleVai = () => {
        this.toggle();
        this.props.vai();
    }

    /**
     * Renders the page
     */
    render() {
        return (
            <div>
                <Button name="filterButton" onClick={this.toggle} style={{width: "100%", height: "100%", padding: "0px", borderWidth: "medium", borderRadius: "25px", textAlign: "center", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent"}}>Filtri</Button>
                <Modal isOpen={this.state.modalOpen} toggle={this.toggle} style={{color: "#011e41"}}>
                    <ModalBody>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            {this.props.children}
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Container className="d-flex justify-content-center align-items-center" fluid>
                            <Button className="text-center" onClick={this.handleAnnulla} style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                Annulla
                            </Button>
                            <Button className="text-center" onClick={this.handleVai} style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                Vai
                            </Button>
                        </Container>
                    </ModalFooter>
                </Modal>            
            </div>
                                              
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/StoricoOrdine/OrdiniFilter.js